import React, { useMemo } from "react";

// Deterministic pseudo-waveform bars from a seed string
function bars(seed, n) {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) % 100000;
  const out = [];
  for (let i = 0; i < n; i++) {
    h = (h * 1103515245 + 12345) % 2147483648;
    const v = 0.22 + (h % 1000) / 1000 * 0.78;
    out.push(v);
  }
  return out;
}

export default function Waveform({ seed = "vok", count = 48, progress = 0, active = false,
  onSeek, height = 40, className = "" }) {
  const data = useMemo(() => bars(seed, count), [seed, count]);
  const handleClick = (e) => {
    if (!onSeek) return;
    const rect = e.currentTarget.getBoundingClientRect();
    onSeek((e.clientX - rect.left) / rect.width);
  };
  return (
    <div
      className={`flex items-end gap-[2px] cursor-pointer select-none ${className}`}
      style={{ height }}
      onClick={handleClick}
      role="slider"
      aria-label="Audio progress"
      aria-valuenow={Math.round(progress * 100)}
      data-testid="waveform"
    >
      {data.map((v, i) => {
        const filled = active && i / count <= progress;
        return (
          <div key={i} className="flex-1 rounded-full transition-colors duration-150"
            style={{
              height: `${Math.round(v * 100)}%`,
              minWidth: 2,
              background: filled ? "#E11D2A" : "#D4D4D8",
            }} />
        );
      })}
    </div>
  );
}
